import { inject } from '@angular/core';
import { ServiceFeatures } from '../models/serviceFeatures';
import { SessionService } from '../services/session.service';

export const welcomeGuard = () => {
	const sessionService: SessionService = inject(SessionService);
	return sessionService.hasFeature(ServiceFeatures.Welcome);
}
